<div class="c-proxy-head">
	{{#if name}}
		<div class="info-block">
			<div class="head-title">
				{{>title}}
			</div>
			{{>img}}
			<div class="head-descr">
				{{>descr}}
			</div>

			<div class="head-links">
				<a href="{{link}}" target="_blank" rel="noopener noreferrer">{{link}}</a>
				<a href="{{docsLink}}" target="_blank" rel="noopener noreferrer">Documentation</a>
				<a href="{{jsDelivrLink}}">jsDelivr Project Page</a>
			</div>
		</div>

		{{>img}}
	{{/if}}
</div>
